/* assets/diabetic-socks-offer.js
 * v2 — preserves existing pack/size/variant/add-to-cart contract.
 *
 * Changes vs prior version:
 *   1. Reads data-default-pack from the selector root and seeds activePackKey
 *      with it (server already marks the matching card .is-active for first paint).
 *   2. Falls back to first available pack if the chosen default is sold out.
 *   3. Dispatches a 'change' event on input[name="id"] after every variant swap
 *      so theme.js (price hydration, payment buttons, sold-out class) reacts
 *      the same way it does on a normal product page.
 *
 * Markup contract is unchanged:
 *   [data-socks-pack-selector]                 — root
 *   [data-pack-card][data-pack-key="packN"]    — pack option button
 *     [data-pack-multiplier], [data-pack-pairs]
 *     [data-pack-card-price], [data-pack-card-compare],
 *     [data-pack-card-save], [data-pack-card-unit]
 *   [data-size-chip][data-size-value]          — size option
 *   [data-socks-pack-products]                 — JSON {pack1,pack2,pack3}
 *   [data-price] / [data-regular-price] / [data-sale-price]
 *   [data-add-to-cart] / [data-add-to-cart-text]
 *   input[name="id"]                            — hidden variant id input
 */
(function () {
  function formatMoney(cents, useCurrencyCode) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      var moneyFormat = useCurrencyCode && theme.moneyFormatWithCurrency ? theme.moneyFormatWithCurrency : theme.moneyFormat;
      return theme.Currency.formatMoney(cents, moneyFormat);
    }
    return ((cents || 0) / 100).toFixed(2);
  }

  function findVariantBySize(product, sizeValue) {
    if (!product || !Array.isArray(product.variants)) return null;
    return (
      product.variants.find(function (v) { return v.available && (v.option1 === sizeValue || v.title === sizeValue); }) ||
      product.variants.find(function (v) { return v.option1 === sizeValue || v.title === sizeValue; }) ||
      product.variants.find(function (v) { return v.available; }) ||
      product.variants[0] ||
      null
    );
  }

  function setButtonState(button, pressed) {
    if (!button) return;
    button.classList.toggle('is-active', !!pressed);
    button.setAttribute('aria-pressed', pressed ? 'true' : 'false');
  }

  function getPackMultiplier(card) {
    if (!card) return 1;
    var n = parseInt(card.getAttribute('data-pack-multiplier') || '1', 10);
    return Number.isFinite(n) && n > 0 ? n : 1;
  }
  function getPackPairs(card) {
    if (!card) return 4;
    var n = parseInt(card.getAttribute('data-pack-pairs') || '4', 10);
    return Number.isFinite(n) && n > 0 ? n : 4;
  }

  function SocksPackSelector(root) {
    this.root = root;
    this.form = root.closest('[data-product-form]') || root.closest('form');
    this.section = root.closest('.dfs-offer-section') || root.closest('[data-section-type="diabetic-socks-offer"]') || root.closest('[id^="ProductSection-"]');
    this.priceContainer = this.section ? this.section.querySelector('[data-price]') : null;
    this.addToCartButton = this.section ? this.section.querySelector('[data-add-to-cart]') : null;
    this.addToCartText = this.addToCartButton ? this.addToCartButton.querySelector('[data-add-to-cart-text]') : null;
    this.variantIdInput = this.form ? this.form.querySelector('input[name="id"]') : null;
    this.productDataEl = root.querySelector('[data-socks-pack-products]');
    this.packCards = Array.prototype.slice.call(root.querySelectorAll('[data-pack-card]'));
    this.sizeChips = Array.prototype.slice.call(root.querySelectorAll('[data-size-chip]'));
    this.useCurrencyCode = root.getAttribute('data-money-with-currency') === 'true';

    // Default pack resolution: explicit attribute → server-rendered .is-active → first card.
    var explicit = root.getAttribute('data-default-pack');
    var serverActive = root.querySelector('[data-pack-card].is-active');
    var firstCard = this.packCards[0];
    if (explicit && root.querySelector('[data-pack-card][data-pack-key="' + explicit + '"]')) {
      this.activePackKey = explicit;
    } else if (serverActive) {
      this.activePackKey = serverActive.getAttribute('data-pack-key');
    } else if (firstCard) {
      this.activePackKey = firstCard.getAttribute('data-pack-key');
    } else {
      this.activePackKey = null;
    }
    var explicitSize = root.getAttribute('data-default-size');
    var serverActiveSize = root.querySelector('[data-size-chip].is-active');
    if (explicitSize) {
      this.activeSize = explicitSize;
    } else if (serverActiveSize) {
      this.activeSize = serverActiveSize.getAttribute('data-size-value');
    } else {
      this.activeSize = this.sizeChips.length ? this.sizeChips[0].getAttribute('data-size-value') : null;
    }
    this.products = {};
  }

  SocksPackSelector.prototype.init = function () {
    if (!this.productDataEl || !this.variantIdInput || !this.packCards.length) return;
    try { this.products = JSON.parse(this.productDataEl.textContent); }
    catch (e) { console.error('Failed to parse socks pack products JSON', e); return; }

    var resolved = this.resolveAvailablePack(this.activePackKey);
    if (resolved && resolved !== this.activePackKey) this.activePackKey = resolved;

    this.bindEvents();
    this.sync(true);
  };

  SocksPackSelector.prototype.resolveAvailablePack = function (preferred) {
    var keys = ['pack1', 'pack2', 'pack3'];
    var ordered = [preferred].concat(keys.filter(function (k) { return k !== preferred; }));
    for (var i = 0; i < ordered.length; i++) {
      var p = this.products[ordered[i]];
      if (!p || !Array.isArray(p.variants)) continue;
      if (p.variants.some(function (v) { return v.available; })) return ordered[i];
    }
    return preferred;
  };

  SocksPackSelector.prototype.bindEvents = function () {
    var self = this;
    this.packCards.forEach(function (card) {
      card.addEventListener('click', function () {
        self.activePackKey = card.getAttribute('data-pack-key');
        self.sync(false);
      });
    });
    this.sizeChips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        self.activeSize = chip.getAttribute('data-size-value');
        self.sync(false);
      });
    });
  };

  SocksPackSelector.prototype.getActiveProduct = function () {
    return this.products[this.activePackKey] || null;
  };

  SocksPackSelector.prototype.sync = function (isInitial) {
    var product = this.getActiveProduct();
    if (!product) return;
    var variant = findVariantBySize(product, this.activeSize);
    if (!variant) return;

    this.activeSize = variant.option1 || variant.title;
    this.variantIdInput.value = variant.id;

    this.updateCardStates();
    this.updateSizeStates();
    this.updateCardPrices();
    this.updateMainPrice(variant);
    this.updateAvailability(variant);

    // Notify theme.js + any other variant-bound UI.
    try { this.variantIdInput.dispatchEvent(new Event('change', { bubbles: true })); }
    catch (e) {}
    try {
      this.root.dispatchEvent(new CustomEvent('variantChange', {
        bubbles: true,
        detail: { variant: variant, product: product, packKey: this.activePackKey, isInitial: !!isInitial }
      }));
    } catch (e) {}
  };

  SocksPackSelector.prototype.updateCardStates = function () {
    var key = this.activePackKey;
    this.packCards.forEach(function (card) { setButtonState(card, card.getAttribute('data-pack-key') === key); });
  };

  SocksPackSelector.prototype.updateSizeStates = function () {
    var size = this.activeSize;
    this.sizeChips.forEach(function (chip) { setButtonState(chip, chip.getAttribute('data-size-value') === size); });
  };

  SocksPackSelector.prototype.updateCardPrices = function () {
    var self = this;
    var baseProduct = this.products.pack1 || null;
    var baseVariant = findVariantBySize(baseProduct, this.activeSize);

    this.packCards.forEach(function (card) {
      var product = self.products[card.getAttribute('data-pack-key')];
      var variant = findVariantBySize(product, self.activeSize);
      if (!variant) return;

      var multiplier = getPackMultiplier(card);
      var pairCount = getPackPairs(card);
      var priceEl = card.querySelector('[data-pack-card-price]');
      var compareEl = card.querySelector('[data-pack-card-compare]');
      var saveEl = card.querySelector('[data-pack-card-save]');
      var unitEl = card.querySelector('[data-pack-card-unit]');
      var ref = baseVariant && multiplier > 1 ? baseVariant.price * multiplier : 0;
      var hasCompare = ref > variant.price;
      var unit = pairCount > 0 ? Math.round(variant.price / pairCount) : variant.price;

      if (priceEl) priceEl.innerHTML = formatMoney(variant.price, self.useCurrencyCode);
      if (compareEl) {
        compareEl.innerHTML = hasCompare ? formatMoney(ref, self.useCurrencyCode) : '';
        compareEl.classList.toggle('hide', !hasCompare);
      }
      if (unitEl) {
        var unitLabel = unitEl.getAttribute('data-unit-label') || '';
        unitEl.innerHTML = formatMoney(unit, self.useCurrencyCode) + (unitLabel ? ' ' + unitLabel : '');
      }
      if (saveEl) {
        var saveLabel = saveEl.getAttribute('data-save-label') || 'Save';
        saveEl.innerHTML = hasCompare ? saveLabel + ' ' + formatMoney(ref - variant.price, self.useCurrencyCode) : '';
        saveEl.classList.toggle('hide', !hasCompare);
      }
      card.classList.toggle('is-unavailable', !variant.available);
      card.disabled = !variant.available;
    });
  };

  SocksPackSelector.prototype.updateMainPrice = function (variant) {
    if (!this.priceContainer) return;
    var regs = Array.prototype.slice.call(this.priceContainer.querySelectorAll('[data-regular-price]'));
    var sale = this.priceContainer.querySelector('[data-sale-price]');
    var activeCard = this.root.querySelector('[data-pack-card][data-pack-key="' + this.activePackKey + '"]');
    var multiplier = getPackMultiplier(activeCard);
    var baseProduct = this.products.pack1 || null;
    var baseVariant = findVariantBySize(baseProduct, this.activeSize);
    var ref = baseVariant && multiplier > 1 ? baseVariant.price * multiplier : 0;
    var onSale = ref > variant.price;
    var useCC = this.useCurrencyCode;

    this.priceContainer.classList.toggle('price--on-sale', !!onSale);
    this.priceContainer.classList.toggle('dfs-price--on-sale', !!onSale);
    this.priceContainer.classList.toggle('price--sold-out', !variant.available);
    this.priceContainer.classList.remove('price--unavailable');

    if (onSale) {
      regs.forEach(function (el) { el.innerHTML = formatMoney(ref, useCC); });
      if (sale) { sale.innerHTML = formatMoney(variant.price, useCC); sale.removeAttribute('hidden'); }
      return;
    }
    regs.forEach(function (el) { el.innerHTML = formatMoney(variant.price, useCC); });
    if (sale) { sale.innerHTML = formatMoney(variant.price, useCC); sale.setAttribute('hidden', ''); }
  };

  SocksPackSelector.prototype.updateAvailability = function (variant) {
    if (!this.addToCartButton || !this.addToCartText) return;
    if (variant.available) {
      this.addToCartButton.removeAttribute('aria-disabled');
      this.addToCartButton.removeAttribute('disabled');
      if (window.theme && theme.strings && theme.strings.addToCart) {
        this.addToCartText.textContent = theme.strings.addToCart;
      }
      return;
    }
    this.addToCartButton.setAttribute('aria-disabled', 'true');
    this.addToCartButton.setAttribute('disabled', 'disabled');
    if (window.theme && theme.strings && theme.strings.soldOut) {
      this.addToCartText.textContent = theme.strings.soldOut;
    }
  };

  function initSelectors(scope) {
    (scope || document).querySelectorAll('[data-socks-pack-selector]').forEach(function (root) {
      if (root.__socksPackSelectorInitialized) return;
      root.__socksPackSelectorInitialized = true;
      var s = new SocksPackSelector(root);
      s.init();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSelectors(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initSelectors(event.target || document);
  });
})();
